import axios from "axios";
import $day from "dayjs"
const module = {
  namespaced: true,
  state: {
    data: {
      user_couple: '',
    },
  },
  mutations: {
    fetchData: (state, info) => {
      if(info.user_couple) {
        info.user_couple.filter((item) => {
          item.editableFlag = true
          return item
        })
        state.data = info
      } else {
        state.data = []
      }

    },
    addData: (state, info) => {
      info.user_couple.editableFlag = true
      state.data.user_couple.push(info.user_couple)
    },
    updateData: (state, info) => {
      return state.data.user_couple = state.data.user_couple.filter((item) => {
        if (item.id == info.id) {
          item = info
        }
        return item
      })
    },
    removeData: (state, info) => {
      return state.data.user_couple = state.data.user_couple.filter((item) => {
        return item.id != info
      })
    },
  },
  actions: {
    async fetchData ({commit}) {
      const response = await axios.get('user/data/couple')
      commit ('fetchData', response.data)

    },
    async updateData ({commit}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      data.relationship = 'Pareja'
      const response = await axios.put('user/data/couple/'+data.id, data)
      commit ('updateData', response.data)
    },
    async addData ({commit}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      data.relationship = 'Pareja'
      const response = await axios.post('user/data/couple', data)
      commit ('addData', response.data)
    },
    async removeData ({commit}, id) {
      await axios.delete('user/data/couple/'+id).then(() => {
        commit ('removeData', id)
      })
    },
  }
}
export default module
